import { deriveErrorResponse } from "../../utils/validation";
export class PlansFailedFetch extends Error {
    constructor(baseError) {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PlansFailedFetch);
        }
        const apiErrorMessages = deriveErrorResponse(baseError);
        const detailMessage = (apiErrorMessages.length > 0 && `Details: ${apiErrorMessages.join(",")}`) || "";
        this.name = "PlansFetchFailed";
        this.message = `Failed to fetch plans. ${detailMessage}`;
    }
}
export class ExpiredScenario extends Error {
    constructor() {
        super();
        this.name = "ExpiredScenario";
        this.message = `Failed to fetch forecast results for scenario: scenario is expired. Please refresh its parent plan.`;
    }
}
export class CorruptedScenarioData extends Error {
    constructor() {
        super();
        this.name = "CorruptedScenarioData";
        this.message = `Failed to fetch forecast results for scenario: its status is ready, but its data is incorrectly formatted.`;
    }
}
export class ScenarioFetchFailed extends Error {
    constructor() {
        super();
        this.name = "ScenarioFetchFailed";
        this.message =
            "Failed to fetch forecast results for scenario: its status is ready, but its data is incorrectly formatted.";
    }
}
export class PlanSaveFailed extends Error {
    constructor() {
        super();
        this.name = "PlanSaveFailed";
        this.message = "Failed to save plan.";
    }
}
export class BadScenarioSavePayload extends Error {
    constructor() {
        super();
        this.name = "BadScenarioSavePayload";
        this.message = "Missing id of parent plan in scenario save payload.";
    }
}
export class ScenarioSaveFailure extends Error {
    constructor() {
        super();
        this.name = "ScenarioSaveFailure";
        this.message = "Failed to save scenario.";
    }
}
export class MalformedScenarioFilters extends Error {
    constructor(planIdFilterSize, scenarioIdFilterSize) {
        super();
        this.name = "MalformedScenarioFilters";
        this.message = `Invalid scenario filters: both planId and scenario id filters must be provided with exactly one value each. Received planId filter size: ${planIdFilterSize}, scenario id filter size: ${scenarioIdFilterSize}.`;
    }
}
export class ScenarioPlanFetchFailed extends Error {
    constructor(baseError) {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ScenarioPlanFetchFailed);
        }
        const apiErrorMessages = deriveErrorResponse(baseError);
        const detailMessage = (apiErrorMessages.length > 0 && `Details: ${apiErrorMessages.join(",")}`) || "";
        this.name = "ScenarioPlanFetchFailed";
        this.message = `Failed to fetch plan while retrieving scenario. ${detailMessage}`;
    }
}
export class ScenarioNotFound extends Error {
    constructor(scenarioId, planId) {
        super();
        this.name = "ScenarioNotFound";
        this.message = `Scenario with id '${scenarioId}' not found in plan '${planId}'.`;
    }
}
export class ScenarioResultsFetchFailed extends Error {
    constructor(baseError) {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ScenarioResultsFetchFailed);
        }
        const apiErrorMessages = deriveErrorResponse(baseError);
        const detailMessage = (apiErrorMessages.length > 0 && `Details: ${apiErrorMessages.join(",")}`) || "";
        this.name = "ScenarioResultsFetchFailed";
        this.message = `Failed to fetch scenario results. ${detailMessage}`;
    }
}
export class ScenarioResultsNotFound extends Error {
    constructor(scenarioId, planId) {
        super();
        this.name = "ScenarioResultsNotFound";
        this.message = `Scenario results not found for scenario '${scenarioId}' in plan '${planId}'. The scenario may still be processing or the results data may be corrupted.`;
    }
}
//# sourceMappingURL=errors.js.map